import React, { useState, useEffect } from "react";
import Phones from "google-libphonenumber";
import Countries from "../../services/countries.service";
import Settings from "../../services/settings.service";
// import CountrySelect from '../shared/country-select-v2.component';
import FieldValidity from "../../services/fieldValidity.service";
import Translation from "../../services/translation.service";
import Protection from "../../services/protection.service";
import Spinner from "../shared/spinner.component";
import Storage from "../../services/storage.service";
import PhoneWrapper from "../shared/sharedFields/phoneWrapper";

// This Component is responsible for validating user
// Validating User with the OTP for reporting

export default function ProtectionChannelOTP(
    {
        setStepDetails = () => { },
        setActiveScreen = () => { },
        setReporterForm = () => { },
    }
) {
    let phoneUtil = Phones.PhoneNumberUtil.getInstance();
    let prefix = "scr_protection_channel";
    let error_prefix = "scr_3.3.3_";
    // let error_prefix = "scr_protection_channel_err_";
    const [loading, setLoading] = useState(false);
    const [showOtpField, setShowOtpField] = useState(false);
    const [otp, setOtp] = useState({
        value: "",
        validations: {
            required: true,
            maxLength: 6,
            minLengthBool: 6
        },
        valid: false,
        touched: false,
    });
    const [formValid, setFormValid] = useState(false);
    const [phoneCode,] = useState({
        value: "SA",
        iso: 966,
        valid: true,
        touched: false,
    });

    const [phone, setPhone] = useState({
        value: "",
        validations: {
            required: true,
            contactNumber: true
        },
        valid: false,
        touched: false,
        dependency: "selected_country_contact",
        error: ""
    });
    useEffect(() => {
        let data_payload = JSON.parse(Storage.get("PrePayload"));
        if (data_payload && data_payload?.ReportingMSISDN) {
            updateContactField(data_payload.ReportingMSISDN)
        }
        if (data_payload && data_payload?.OTP) {
            setShowOtpField(true);
            updateOtpField(data_payload.OTP)
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps



    const updateContactField = (value) => {
        let validcontact = "";
        if (value.length > 6 && Settings.formats.phonenumber.test(value)) {
            let country = null;
            let dependency = phoneCode?.value;
            country = Countries.Countries[dependency];
            if (country && country.ISO_2Code) {
                let number = phoneUtil.parse(value, country.ISO_2Code);
                validcontact = phoneUtil.isValidNumber(number);
            } else {
                validcontact = Settings.formats.phonenumber.test(value);
            }
        } else {
            validcontact = false;
        }
        let errorMsg = ""
        if (!validcontact && !value) {
            errorMsg = Translation.keys[error_prefix + "error_required_message"]
        } else if (!validcontact && value) {
            errorMsg = Translation.keys[error_prefix + "error_number_invalid"]
        } else {
            errorMsg = ""
        }
        setPhone({
            ...phone,
            value: value,
            data_submition: true,
            valid: validcontact,
            touched: true,
            error: errorMsg
        })
        if (validcontact) {
            setFormValid(true);
        }
        else {
            setOtp({
                ...otp,
                value: "",
                valid: false,
                touched: false
            })
            setFormValid(false);
        }
    }

    const updateOtpField = (data) => {
        let validOTP = FieldValidity.checkFieldValidity(data, otp.validations);
        setOtp({
            ...otp,
            value: data,
            valid: validOTP,
            touched: true
        })
        // if(validOTP) {
        //     setOtpError(false);
        // } else {
        //     setOtpError(true);
        // }
    }

    const handleGetOTP = () => {
        setShowOtpField(true);
        setOtp({
            ...otp,
            value: "",
            valid: false,
            touched: false,
        })
        setLoading(true)
        let data = {
            number: phone?.value,
            fraud_type: "ProtectionChannel"
        }
        Protection.getOTP(data)
            .then(response => {
                if (response && response?.data) {
                    setLoading(false);
                    window.scrollTo(0, window.innerHeight / 6);
                }
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const handleVerifyOTP = () => {
        setLoading(true)
        Storage.clear("reportOtpError");
        let payloads = {
            number: phone?.value,
            otp: otp?.value
        }
        Storage.set("reportOtpError", true, true);
        Protection.verifyOTP(payloads)
            .then(response => {
                if (response && response?.data) {
                    setReporterForm({
                        number: phone?.value,
                        otp: otp?.value
                    })
                    setStepDetails((prevState) => ({
                        ...prevState,
                        step1: { status: "isDone" },
                        step2: { status: "inProgress" }
                    }));
                    setActiveScreen("ReasonScreen")
                } else {
                    setLoading(false);
                    setOtp({
                        ...otp,
                        valid: false,
                    })
                }
                window.scrollTo(0, window.innerHeight / 6);
            })
            .catch(error => {
                setLoading(false);
                setOtp({
                    ...otp,
                    valid: false
                });
                Storage.clear("reportOtpError");
            });
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (!showOtpField && formValid && phone.valid) {
                handleGetOTP();
            } else if (showOtpField && otp.valid && phone.valid) {
                handleVerifyOTP();
            }
        }
    };

    return (
        <div className="protection-form-container">
            <div className="field-section">
                {loading ? <Spinner /> :
                    <>
                        <div className="field-container">
                            <label>{Translation.keys[prefix + "_contact_number"]}</label>
                            <PhoneWrapper>
                                <input
                                    type="tel"
                                    className={
                                        "storefront-search-input " +
                                        (!phone.touched || (phone.touched && phone.valid)
                                            ? "valid"
                                            : "invalid") +
                                        (phone.value ? " filled" : "")
                                    }
                                    name="contact_number"
                                    id="contact_number"
                                    value={phone.value}
                                    placeholder={Translation.keys[prefix + "_contact_number"]}
                                    onChange={event => {
                                        if (FieldValidity.inputDigits(event, 10)) {
                                            updateContactField(event.target.value, "form", 'phone')
                                        }
                                    }}
                                    onKeyDown={handleKeyDown}
                                />
                            </PhoneWrapper>
                        </div>

                        {showOtpField && phone.valid &&
                            <>
                                <div className="field-container">
                                    <label>{Translation.keys[prefix + "_enter_otp"]}</label>
                                    <input
                                        className={
                                            "storefront-search-input " +
                                            (!otp.touched || (otp.touched && otp.valid)
                                                ? "valid"
                                                : "invalid") +
                                            (otp.value ? " filled" : "")
                                        }
                                        name="otp"
                                        type="text"
                                        value={otp?.value}
                                        placeholder={Translation.keys[prefix + "_enter_otp"]}
                                        onChange={event => {
                                            if (FieldValidity.inputDigits(event, 6)) {
                                                updateOtpField(event?.target?.value)
                                            }
                                        }}
                                        onKeyDown={handleKeyDown}
                                    />
                                    <div className="resend-otp" onClick={() => {
                                        handleGetOTP()
                                    }}>{Translation.keys[prefix + "_resend"]}
                                    </div>
                                    {!otp.valid && otp.touched ?
                                    <span className="error-msg">
                                        {Translation.keys["stf_protection_channel_please_enter_otp"] || "Please enter valid OTP"}
                                    </span> : null}
                                </div>
                                <button
                                    className="common-button"
                                    disabled={!otp.valid || !phone.valid}
                                    onClick={() => {
                                        handleVerifyOTP()
                                    }}
                                >
                                    {Translation.keys[prefix + "_next"]}
                                </button>
                            </>
                        }

                        {!showOtpField &&
                            <button
                                className="common-button"
                                disabled={!formValid || !phone.valid}
                                onClick={() => {
                                    handleGetOTP()
                                }}
                            >
                                {Translation.keys[prefix + "_send_code"]}
                            </button>
                        }
                    </>
                }
            </div>
        </div>
    )
}